import React from "react";
import S from "./NodeCounter.styled";
import { motionAnimation } from "@/styles/global";
import { motion } from "framer-motion";

export interface INodeCounterProps {
  startDate: string;
  startNumber: number;
  nodeInterval: number;
  nodeIncrement: number;
  blockId: string;
}

const NodeCounter: React.FC<INodeCounterProps> = ({
  blockId = "",
  startDate,
  startNumber,
  nodeInterval,
  nodeIncrement,
}) => {
  const [nodeCount, setNodeCount] = React.useState(0);

  //set the starting point of the nodeCount 26/09/2024 00:00:00
  React.useEffect(() => {
    const start = new Date(startDate);
    const now = new Date();
    const diffInMilliseconds = now.getTime() - start.getTime();
    const diffInSeconds = Math.floor(diffInMilliseconds / 1000); // Convert to full seconds

    // Calculate how many intervals have passed and how much to increment by
    const intervalsPassed = Math.floor(diffInSeconds / nodeInterval);
    const newCount = startNumber + intervalsPassed * nodeIncrement;

    setNodeCount(newCount);
  }, [startDate, nodeInterval, nodeIncrement, startNumber]);

  //for each nodeInterval, increment the nodeCount by nodeIncrement with startDate as the starting point
  React.useEffect(() => {
    //interval is 12 seconds, has value 12
    const intervalSeconds = nodeInterval * 1000;
    const interval = setInterval(() => {
      setNodeCount((prev) => prev + nodeIncrement);
    }, intervalSeconds);
    return () => clearInterval(interval);
  }, [nodeIncrement, nodeInterval]);

  const formattedNodeCount = new Intl.NumberFormat("us-US").format(nodeCount);

  return (
    <S.Section id={blockId} as={motion.section} {...motionAnimation}>
      <S.Inner>
        <S.CounterContainer>
          <S.Title>Wirepas In</S.Title>
          <S.Counter>
            <S.CounterValue>{formattedNodeCount}</S.CounterValue>
          </S.Counter>
          <S.SmallText>devices</S.SmallText>
        </S.CounterContainer>
      </S.Inner>
    </S.Section>
  );
};

export default NodeCounter;
